import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

/**
 * Inicializa a instância MSAL antes do bootstrap do Angular.
 * Necessário para que o cliente OAuth processe redirecionamentos OAuth
 * antes de o router avaliar as rotas.
 * A verificação do estado de autenticação é responsabilidade do AppComponent.
 */
@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private readonly msalService = inject(MsalService);

  async initialize(): Promise<void> {
    try {
      await this.msalService.instance.initialize();
    } catch {
      // Instância já inicializada ou erro não-crítico
    }
  }
}
